// import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

/**
 * 车型列表配置 - 用于 BaseListManagement
 */
export const carModelTableConfig = ({
  handleSetCarInfo,
  handleConfigPlan,
  handleSelect,
  checkSelectable,
  apiFn,
  // handleCustomizeReset,
}) => ({
  isShowDepartment: false,
  formData: {
    formProps: {
      model: {
        // brandSeriesModel: {},
        // cityCode: '',
      },
    },
    // customizeReset: handleCustomizeReset,
    // list: [
    //   {
    //     itemConfig: {
    //       prop: 'brandSeriesModel',
    //     },
    //     elConfig: {
    //       showModel: true,
    //       filterScene: CAR_MODEL_FILTER_SCENE.LEASE_PLAN,
    //     },
    //     render: 'CarBrandSeriesModel',
    //   },
    //   {
    //     el: 'select',
    //     itemConfig: {
    //       label: '上架城市',
    //       prop: 'cityCode',
    //     },
    //     elConfig: {
    //       filterable: true,
    //       clearable: true,
    //       placeholder: '请选择',
    //       options: {
    //         label: 'city',
    //         value: 'adcode',
    //         list: [], // 动态加载
    //       },
    //     },
    //   },
    // ],
  },
  tableData: {
    apiFn,
    attrs: {},
    events: {
      select: handleSelect,
      'select-all': () => {
        // 禁用全选功能，不做任何操作
        return false
      },
    },
    columns: [
      {
        name: 'selection',
        columnProps: {
          prop: 'selection',
          type: 'selection',
          width: 55,
          selectable: checkSelectable,
          reserveSelection: false, // 禁用跨页保留选中
        },
      },
      {
        name: 'carModelName',
        columnProps: {
          prop: 'carModelName',
          label: '车型名称',
          minWidth: 200,
        },
        render: ({ row }) => {
          // 只有当品牌名和系列名都存在时才显示分隔点
          const brandSeries = [row.brandName, row.seriesName]
            .filter(Boolean)
            .join('·')
          return (
            <div class="model-name">
              {brandSeries && <span class="brand">{brandSeries}</span>}
              <span class="name">{row.carModelName}</span>
            </div>
          )
        },
      },
      {
        name: 'modelYear',
        columnProps: {
          prop: 'modelYear',
          label: '年款',
          width: 100,
        },
      },
      {
        name: 'operationTypeName',
        columnProps: {
          prop: 'operationTypeName',
          label: '运营类型',
          width: 100,
        },
      },
      {
        name: 'selectPlanAndCodeCount',
        columnProps: {
          prop: 'selectPlanAndCodeCount',
          label: '已选方案',
          width: 100,
        },
        render: ({ row }) => {
          return <span>{row.selectPlanAndCodeCount || 0}个</span>
        },
      },
      {
        name: 'groupCarModelInfoState',
        columnProps: {
          prop: 'groupCarModelInfoState',
          label: '车型信息状态',
          width: 120,
        },
        render: ({ row }) => {
          return (
            <span
              class={row.groupCarModelInfoState === 1 ? 'status-custom' : ''}
            >
              {row.groupCarModelInfoState === 1 ? '单独设置' : '默认设置'}
            </span>
          )
        },
      },
      {
        name: 'operate',
        columnProps: {
          prop: 'operate',
          label: '操作',
          width: 200,
          fixed: 'right',
        },
        render: ({ row }) => {
          return (
            <div>
              <el-button type="text" onClick={() => handleSetCarInfo(row)}>
                设置车型信息
              </el-button>
              <el-button
                type="text"
                disabled={!row.canSelect}
                onClick={() => handleConfigPlan(row)}
              >
                配置已选方案
              </el-button>
            </div>
          )
        },
      },
    ],
    pagination: {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pagerCount: 5,
    },
  },
})
